export default {
  userInitials (state) {
    let name
    if (state.user.name) {
      name = state.user.name.split(' ')
    } else {
      name = ' '
    }
    if (name.length > 1) {
      return name[0].charAt(0) + name[1].charAt(0)
    } else {
      return name[0].charAt(0)
    }
  },
  isLoggedIn (state) {
    return state.env.api_token != null
    // return state.user.loggedIn
  }
}



// WEBPACK FOOTER //
// ./src/store/getters.js